import { Routes } from '@angular/router';

import {
  CAMINHO_ANTIGO_DO_ASSISTENTE,
  CAMINHO_DO_ASSISTENTE_IZII,
} from 'src/app/core/config/chat-ia';
import { AuthGuard } from 'src/app/core/guards/auth';
import { chatIaDisponivelGuard } from 'src/app/core/guards/chat-ia';

/**
 * Rotas do Assistente Izii (chat com IA), espalhadas no app-routing antes do
 * '**'. Ficam aqui para a spec do guard navegar nelas mesmas, e nao numa copia.
 *
 * So dev e local. Com a chave chatIaDisponivel desligada a rota da tela nao
 * casa: o modulo nem e baixado e a URL cai no '**' (dashboard). Quem decide o
 * acesso aos dados e o backend (vinculo com a empresa do header; 404 com
 * ChatIa:Habilitado desligado).
 */
export const ROTAS_DO_ASSISTENTE_IZII: Routes = [
  {
    path: CAMINHO_DO_ASSISTENTE_IZII,
    loadChildren: () =>
      import('./assistente-de-faturas.module').then(
        (m) => m.AssistenteDeFaturasModule
      ),
    canMatch: [chatIaDisponivelGuard],
    canActivate: [AuthGuard],
  },
  {
    // Endereco antigo, de favorito ou de link: leva ao novo. Com a chave
    // desligada o novo nao casa e a URL cai no '**' (dashboard), como antes.
    // O redirect e relativo de proposito: depois de um redirect absoluto
    // ('/assistente-izii') o Router nao aplica mais nenhum, e com a chave
    // desligada o '**' nao pegaria (erro de navegacao em vez do dashboard).
    path: CAMINHO_ANTIGO_DO_ASSISTENTE,
    pathMatch: 'full',
    redirectTo: CAMINHO_DO_ASSISTENTE_IZII,
  },
];
